import {cva} from 'class-variance-authority'

/**
 * Tooltip bubble (Figma "<Tooltip>", node 324:15170 — MUI Tooltip).
 * Dark-teal `primary-contrast` (#004E56, the `_components/tooltip/fill` token) fill,
 * white `text-inverse` label at the 10px `tooltip` type token, 8px radius.
 */
export const TooltipVariantsFactory = cva(
  'z-50 max-w-xs rounded-lg bg-primary-contrast px-2 py-1 text-tooltip text-text-inverse',
)
